// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-td {
  height: 36px;
  padding: 0 var(--admin-s4);
  color: var(--admin-text-primary);
  font-size: var(--admin-text-base);
  font-weight: var(--admin-font-weight-normal);
  vertical-align: middle;
}

.au-td--muted,
.au-td .is-muted {
  color: var(--admin-text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminTd.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,0BAA0B;EAC1B,gCAAgC;EAChC,iCAAiC;EACjC,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;;EAEE,kCAAkC;AACpC","sourcesContent":[".au-td {\n  height: 36px;\n  padding: 0 var(--admin-s4);\n  color: var(--admin-text-primary);\n  font-size: var(--admin-text-base);\n  font-weight: var(--admin-font-weight-normal);\n  vertical-align: middle;\n}\n\n.au-td--muted,\n.au-td .is-muted {\n  color: var(--admin-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
